<mat-drawer-container [hasBackdrop]="false" style="overflow: hidden">
  <mat-drawer #sidenav mode="side" position="end">
    <h3 class="title">Sharing requests</h3>
    <div *ngIf="contacts.length > 0">
      <usimweb-notification [contacts]="contacts"></usimweb-notification>
    </div>
  </mat-drawer>
  <mat-drawer-content style="background-color: white">
    <usimweb-header [app]="app" [user]="user" (logoutEvent)="logout()"></usimweb-header>
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
<!-- <usimweb-drawer
  [contacts]="contacts"
  [app]="app"
  [user]="user"
  [color]="color"
  (logoutEvent)="logout()"
></usimweb-drawer> -->
